import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FormDTO, Prefrence, ReferralResponse, verifyMemberRequest, verifyMemberResponse } from 'src/app/module/pierhippar/model/interfaces';

import { config } from 'src/app/shared/config';

@Injectable()
export class DataService {
  private apiUrl: string = config.PIERHIPPARapiUrl;
  private initialDataUrl: string = this.apiUrl.concat('/getOnlinePageData');
  private verifyMemberUrl: string = this.apiUrl.concat('/validateMember');
  private saveBaseUrl: string = this.apiUrl.concat('/saveOnlineApplication');

   headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
    .set('Access-Control-Allow-Origin',config.PIERHIPPARapiUrl)
    .set("Access-Control-Allow-Headers", "Origin, Authorization, Content-Type, Accept")
    .set('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');

    //CORS
   // headers = new HttpHeaders().set("Access-Control-Allow-Origin", "*")
   // .set('Content-Type', 'application/json; charset=utf-8')
   // .set("Access-Control-Allow-Headers", "Origin, Authorization, Content-Type, Accept")
    //.set('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE,PATCH,OPTIONS');

    constructor(private http: HttpClient) {
    }

   public insertCustomerForm(customer: FormDTO): Observable<ReferralResponse> {
        return this.http.post<ReferralResponse>(this.saveBaseUrl, customer, { 'headers': this.headers })
            .pipe(catchError(this.handleError));
    }


    getPreference(): Observable<Prefrence>{
      return this.http.get<Prefrence>(this.initialDataUrl, { 'headers': this.headers })
            .pipe(catchError(this.handleError));
    }

    getVerifyExistingMember(member: verifyMemberRequest): Observable<verifyMemberResponse>{
      return this.http.post<verifyMemberResponse>(this.verifyMemberUrl, member, { 'headers': this.headers })
            .pipe(catchError(this.handleError));
    }


    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(() => errMessage);
            // Use the following instead if using lite-server
            // return Observable.throw(err.text() || 'backend server error');
        }
        return throwError(() => error || 'Online server error');
    }



}

